import React, { useState, useContext, useEffect } from 'react'
import { s3Static } from '../../../../utils/constants'
import Image from 'next/image'
import { motion } from 'framer-motion'
import { Services } from '../../service/Services'
import { RequestProvider } from '../../../../context/RequestContext'
import { useRouter } from 'next/router'
import { LoadingCover } from '../../../commons/LoadingCover'
import { LocationContext } from '../../../../context/LocationContext'
import Link from 'next/link'
import { Locality } from '../../commons/Locality'
import { FaMapMarkerAlt } from 'react-icons/fa'
import { openModal } from '../../../../service/modal-service'

export const PropertyAgent = (props) => {
  const requestCategorySettings = props.requestCategorySettings;
  const countryName = props.countryName
  const localityDetails = props.localityDetails
  // const month = props.month
  // const year = props.year
  const spList = props.spList
  const h1Tag = props.h1Tag
  const requestType = 'Housing'

  const router = useRouter()  

  const routeLocality = router.query.locality

  const [ requestForm, setRequestForm ] = useState(router.query.requestForm)
  const { locality } = useContext(LocationContext)
  const [ isLoading, setIsLoading ] = useState(false)  
  

  useEffect(() => {
      // setRequestForm(true)
      openModal(setRequestForm)
  }, [])

  const openRequestForm = () => {
      window.scrollTo({ top: 0 });
      // setRequestForm(true)
      openModal(setRequestForm)
  }

  return (
    <>
        <div id="property-agent" className="h-screen -mb-14">
            <div className="h-full w-full">
              <Image className='bg-linear-to-br from-slate-800 to-orange-300'
                  src={s3Static + "Property-Agent-Singapore.jpg"}
                  fill
                  style={{objectFit: 'cover', objectPosition: 'top'}}
                  alt='Financial Planning'
                  priority="false"
                  quality={100}
                  sizes="(max-width: 768px) 100vw, 33vw"
                  />
            </div>        
            <div id="campaign" className='absolute top-1/2 -translate-y-1/2 w-full'>
                {requestForm ?
                  <RequestProvider>
                      <Services requestType={requestType} requestCategorySettings={requestCategorySettings} setRequestForm={setRequestForm}/>
                  </RequestProvider> 
                  :
                  <div className='bg-black/30 rounded-lg w-fit mx-auto p-2 space-y-2 text-center text-white'> 
                      <div className='py-3'>
                        <button type="button" className='px-6 py-3 border border-white text-2xl rounded-lg font-bold' onClick={() => openRequestForm()}>
                           Request Now
                        </button>
                      </div>
                    <p className='text-lg'><strong>Find your perfect house</strong></p>
                  </div>  
                } 
            </div>
        </div> 
        <h1 className='px-6 text-xl text-center text-gray-500'>
            {h1Tag}
            {localityDetails?.name ?
                <span>
                    &nbsp;{localityDetails.name}
                </span>
                :
                <span>
                    &nbsp;{countryName}
                </span>
            }
            &nbsp;- Real Estate
        </h1>   
        {localityDetails ?
            <div className='p-6 space-y-5 max-w-5xl mx-auto'>
                {localityDetails?.name ?
                    <Locality localityDetails={localityDetails}/>
                    :
                    <p className='text-gray-500 break-words whitespace-pre-wrap text-sm leading-6'>
                        Get the best Property Agent Singapore for all your housing needs. StringsSG will connect you the most relevant Property Agent
                        based on your requirements. We cover all of Singapore including locations like Tampines, Ang Mo Kio, Jurong, Punggol, Paris Ris etc.
                    </p>
                }
                {localityDetails.name > "" &&
                    <p className='text-gray-500 break-words whitespace-pre-wrap text-sm leading-6'>
                        We aim to help people in {localityDetails.name} in finding the right housing to fit their budget and requirements.
                    </p>
                }
            </div>
            :
            <div className='p-6 space-y-5 max-w-5xl mx-auto'>
                <p className='text-gray-500 break-words whitespace-pre-wrap text-sm leading-6'>
                    Get the best Property Agent Singapore for all your housing needs. StringsSG will connect you the most relevant Propert Agent
                    based on your requirements. We cover all of Singapore including locations like Tampines, Ang Mo Kio, Jurong, Punggol, Paris Ris etc.
                </p>
            </div>
        }
        <div id="how-it-works" className="w-full relative max-w-4xl mx-auto" style={{"height": "850px"}}>
            <Image className=''
                src={s3Static + "property-agent-png.png"}
                fill
                style={{objectFit: 'cover', objectPosition: 'top'}}
                priority="false"
                alt='female property agent'
                sizes="(max-width: 768px) 100vw, 33vw"
            />
            <div className='relative text-white max-w-4xl mx-auto space-y-12 text-center p-2'> 
                <div className='text-orange-600 text-3xl pt-6 font-bold'>How it works?</div> 
                <motion.div className='flex'
                  initial={{
                    x: "-100%"
                  }}
                  whileInView={{
                    x: 0,
                  }}
                  transition={{
                    duration: 0.5,
                  }}
                >
                  <div id="m1" className="flex px-4 py-4 bg-linear-to-br from-amber-600 to-amber-400 rounded-full">
                      <p> 
                       Let us know your housing requirements along with your other preferences
                      </p>
                  </div>
                </motion.div>
                <motion.div className='flex justify-end'
                  initial={{
                    x: "100%"
                  }}
                  whileInView={{
                    x: 0,
                  }}
                  transition={{
                    duration: 0.5,
                  }}                
                >
                  <div id="m2" className="block px-4 py-4 bg-linear-to-br from-amber-600 to-amber-400 rounded-full">
                      <p className=''> 
                            View instant responses from the best matching Property Agents in {locality}
                      </p>
                  </div>
                </motion.div>
                <motion.div className='flex'
                  initial={{
                    x: "-100%"
                  }}
                  whileInView={{
                    x: 0,
                  }}
                  transition={{
                    duration: 0.5,
                  }}
                >
                  <div id="m3" className="block px-4 py-4 bg-linear-to-br from-amber-600 to-amber-400 rounded-full">
                      <p> 
                        View Property Agent&apos;s profile, pictures, reviews and ratings
                      </p>
                  </div>
                </motion.div>
                <motion.div className='flex justify-end'
                  initial={{
                    x: "100%"
                  }}
                  whileInView={{
                    x: 0,
                  }}
                  transition={{
                    duration: 0.5,
                  }}                
                >
                  <div id="m4" className="px-4 py-4 bg-linear-to-br from-amber-600 to-amber-400 rounded-full">
                      <p> 
                      Chat, call or SMS the matched Property Agents you short-listed
                      </p>
                  </div>
                </motion.div>
                <motion.div className='flex'
                  initial={{
                    x: "-100%"
                  }}
                  whileInView={{
                    x: 0,
                  }}
                  transition={{
                    duration: 0.5,
                  }}
                >
                  <div id="m5" className="block px-4 py-4 bg-linear-to-br from-amber-600 to-amber-400 rounded-full">
                      <p> 
                      Select the Property Agent who best matches your needs
                      </p>
                  </div>
                </motion.div>
                <motion.div className='flex justify-end'
                  initial={{
                    x: "100%"
                  }}
                  whileInView={{
                    x: 0,
                  }}
                  transition={{
                    duration: 0.5,
                  }}                
                >
                  <div id="m6" className="px-4 py-4 bg-linear-to-br from-amber-600 to-amber-400 rounded-full">
                      <p> 
                      Rate and write a review on the Property Agent&apos;s service
                      </p>
                  </div>
                </motion.div>
            </div>
        </div> 
        <div className='py-10 space-y-5 max-w-5xl mx-auto'>
            <h2 className='px-6 text-xl text-center text-gray-500'>
                Top 10 Property Agents in 
                {localityDetails?.name ?
                    <span>
                        &nbsp;{localityDetails.name}
                    </span>
                    :
                    <span>
                        &nbsp;{countryName}
                    </span>
                }
            </h2>
            <div className='p-2 grid grid-cols-1 md:grid-cols-2 gap-5'>  
                {[...spList].map((sp, i) => 
                    <div key={i} className='shadow-sm p-2 md:h-72 overflow-y-auto scrollbar-hide'>
                        <div className='flex items-center space-x-3'>
                            <div className=''>  
                                <Link href={`/profile/${sp.handleName}`} prefetch={false} className='flex'>
                                        <span className='relative w-28 h-28'>
                                            <Image className='rounded-lg'
                                                src={sp.profilePic}
                                                fill
                                                style={{objectFit: 'cover'}}
                                                placeholder='blur'
                                                blurDataURL={s3Static + "placeholder.png"}
                                                alt='profile image'
                                                sizes="(max-width: 768px) 100vw, 33vw"
                                            />                                
                                        </span>
                                </Link>
                            </div>
                            <div className='space-y-1'>
                                <Link href={`/profile/${sp.handleName}`} prefetch={false} className='text-orange-600'>
                                        <h3>{sp.userFirstName}&nbsp;{sp.userLastName}</h3>
                                </Link>
                                <div className='text-sm text-gray-500'>
                                    Service - {sp.category}
                                </div>
                                <div className='flex items-center space-x-1 text-2xs text-gray-400 pt-1'>
                                    <FaMapMarkerAlt/>
                                    <div>{sp.userLocation}</div>
                                </div>
                            </div>                
                        </div>
                        <div className='py-2'>
                            <p className='text-gray-500 break-words whitespace-pre-wrap text-xs leading-5'>
                                {sp.description}
                            </p>
                        </div>
                    </div>
                )}
            </div>
        </div>
        <div className='max-w-5xl mx-auto py-6 px-2 text-gray-500 text-sm'>
              <p className='text-2xl text-center'>
                  Why get housing solutions from our platform?
              </p>
              <div className='py-4 grid grid-cols-1 md:grid-cols-2 space-y-2'>
                  <div className='space-y-2'>
                      <p className='leading-6'>
                          <strong>It&apos;s free - </strong><span>We do not charge any fee to users for submitting a request and it will always be free!</span>
                      </p>
                      <p className='leading-6'><strong>We are not a property agency - </strong>
                        We are an open platform to all property agents in the city, which means your search is not limited to 
                        a single agency or agent. You get to choose from a variety of service providers from all over the 
                        city. 
                        We have service providers from several agencies like <a className='text-orange-500' href="https://www.propnex.com/">PropNex</a>,&nbsp; 
                        <a className='text-orange-500' href="https://www.era.com.sg/">ERA real Estate</a> and many more.
                      </p>
                      <p className='leading-6'><strong>It&apos;s your choice  - </strong>
                        We do not impose a particular house or property agent on you. The wide choice of property and agents 
		        		gives you the opportunity to select the best for yourself.
                      </p>
                  </div>
                  <div className='p-2 text-center relative space-y-10'>
                      <div className='relative w-full h-96'>                        
                          <Image className='rounded-lg relative'
                              src={s3Static + "Real-Estate-Agent.jpg"}
                              fill
                              style={{objectFit: 'cover'}}
                              alt='Property agent with key'
                              placeholder="blur"
                              blurDataURL={s3Static + "placeholder.png"}
                              sizes="(max-width: 768px) 100vw, 33vw"
                          />
                      </div>   
                      {/* <div>
                        <Link {...(routeLocality) 
                            ? {href: `/sg/property-agent/${routeLocality}/property-agent-list`}
                            : {href: `/sg/property-agent/${locality}/property-agent-list`}}  
                             prefetch={false} className='px-6 py-3 text-lg text-white bg-linear-to-tr from-amber-600 to to-amber-300 rounded-xl'>
                                  Browse Property Agents
                        </Link>
                      </div>  */}
                  </div>
              </div>
              <div className='space-y-2'>
                <p className='leading-6'><strong>Custom tailored for you - </strong>
                    While submitting a request, you can exactly say what your expectations are from, you can add multiple criteria.
                    The responses you receive from the service providers will be sorted in order of the match percent to your requirements. This gives
                    you the option to pick the best housing solution for you.
                </p>
            </div>
        </div>
        <div className='fixed bottom-0 w-full text-center text-lg'>    
            <button type="button" className='text-white py-3 bg-linear-to-tr from-amber-600 to-amber-400 block font-bold w-full' onClick={() => openRequestForm()}>
                Request for a Property Agent
            </button>    
        </div> 
        {isLoading &&
          <LoadingCover/>
        }
    </>
  )
}
